import CollectionsAlerts from "./CollectionsAlerts"
export default CollectionsAlerts